"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const qs_1 = __importDefault(require("qs"));
const API = {
    listLogs: '/api/ac/v2/systemlog/published/list',
};
class ActivityLog {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    /**
     * Function to get list service
     * @param filter - filter by name or client_id. Eg: {name:'dev',client_id:'dev}
     * @param sort - field and order to sort. Eg: {name: 'asc',createdAt:'asc'}
     * @param page - page number
     * @param limit - limit number
     * @returns Return list service data
     */
    async getListLog(filter, page, limit) {
        const query = {
            page,
            filter,
            limit,
        };
        const url = `${API.listLogs}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: {
                activityLogs: resBody.entities.systemLogs,
            },
        };
    }
}
exports.default = ActivityLog;
